module.exports = __webpack_public_path__ + "static/media/LOGO-Mapfre-white.557646b4.png";